import React from 'react'
import { connect } from 'react-redux'
import { getRdPinData } from '../../../store/Procurement/actionCreator'
import MrtReusableTable from '../../Utils/MrtReusableTable'
import { handleFireflySendEvent } from '../../Utils/FireFlyVnextHelpers'

export class rdPinTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      rdPinFileList: [],
      loading: true,
    }
    this.baseState = { ...this.state }
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.props.getRdPinData()
    this.setState({
      rdPinFileList: this.props.rdPinFileList,
      loading: false,
    })
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'R&D PIN Inventory',
        'R&D PIN Inventory Tab Load',
        userInfo,
      )
    }
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
    },
  }

  render() {
    const columns = [
      {
        accessorKey: 'manufacturer',
        header: 'Manufacturer',
      },
      {
        accessorKey: 'owner',
        header: 'Owner',
        size: 150,
      },
      {
        accessorKey: 'inventory_rd_pin',
        header: 'Inventory R&D PIN',
        size: 100,
      },
      {
        accessorKey: 'pin_description',
        header: 'PIN Description',
        size: 125,
      },
      {
        accessorKey: 'upn',
        header: 'UPN',
        size: 100,
      },
      {
        accessorKey: 'description',
        header: 'Description',
        size: 300,
      },
      {
        accessorKey: 'inventory_warehouse',
        header: 'Warehouse',
        size: 75,
      },
      {
        accessorKey: 'qty_repair',
        header: 'Qty Repair',
        size: 25,
      },
      {
        accessorKey: 'qty_on_po',
        header: 'Qty on PO',
        size: 25,
      },
      {
        accessorKey: 'qty_usable',
        header: 'Qty Usable',
        size: 25,
      },
    ]

    const defaultColumns = [
      'owner',
      'inventory_rd_pin',
      'pin_description',
      'upn',
      'description',
      'inventory_warehouse',
      'qty_repair',
      'qty_on_po',
      'qty_usable',
    ]

    return (
      <MrtReusableTable
        pageSize={[100, 200, 500]}
        pageTitle={'R&D PIN Inventory'}
        columns={columns}
        rowData={this.props.rdPinFileList}
        defaultColumns={defaultColumns}
        loading={this.state.loading}
        loadingMessage="Loading PIN Inventory..."
      />
    )
  }
}

const mapStateToProps = (state) => ({
  rdPinFileList: state.procurement.rdPinFileList || [],
  userInfo: state.auth.userInfo,
})

const mapDispatchToProps = {
  getRdPinData,
}

export default connect(mapStateToProps, mapDispatchToProps)(rdPinTab)
